import React from 'react'
import { Button, Modal, ModalBody, Row, Col, Form, Input, CardBody, Media, Label } from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalLiquidacion = (props) => {

    const { loadingPayment, modal, toggle, handleInputChangeLiquided, saveLiquided, listPayMethod, loading, validatesaveLiquided, id_method_liquided, amount_liquided, id_method_pay, amount_liq } = props;


    const {
        id_method_pay_valid,
        amount_liquided_valid,

    } = validatesaveLiquided;

    return (
        <Dialog
            header={"Liquidar Saldos"}
            visible={modal}
            onHide={toggle}
            closable
            modal
            style={{ width: "650px" }}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            className="pt-0 custom-dialog-img"

            footer={
                <div className="d-flex justify-content-end gap-2">


                    <Button
                        disabled={loadingPayment}
                        color="secondary"
                        type="button"
                        onClick={saveLiquided}
                    >
                        Autorizar
                    </Button>
                    <Button
                        disabled={loadingPayment}
                        color="danger"
                        type="button"
                        onClick={toggle}
                    >
                        Cancelar
                    </Button>
                </div>
            }
        >

            <Form className="theme-form" role="form">

                <Row className="align-items-stretch">

                    <Col md="4" className="d-flex justify-content-center align-items-center border-end">

                        <div className="side-lock-wrapper-2">
                            <img
                                src={require("../../assets/images/blog/password.svg")}
                                alt="user"
                                className="side-lock-icon"
                            />
                        </div>

                    </Col>

                    <Col md="8">

                        <Row className="g-3 mb-3">

                            <Col md="12">
                                <Label className="form-label-sm">Método de Pago</Label>
                                <Input
                                    type="select"
                                    name="id_method_pay"
                                    value={id_method_pay}
                                    invalid={id_method_pay_valid}
                                    onChange={handleInputChangeLiquided}
                                    className="form-control form-control-sm custom-input"
                                >
                                    <option value={0}>Selecciona una opción</option>

                                    {
                                        listPayMethod.length > 0 &&
                                        listPayMethod.map(pm => {
                                            if (pm.name !== "CREDITO") {
                                                return (
                                                    <option
                                                        key={'method-' + pm.id_pay_method}
                                                        value={pm.id_pay_method}
                                                    >
                                                        {pm.abbreviation} - {pm.name}
                                                    </option>
                                                )
                                            }
                                        })
                                    }
                                </Input>
                            </Col>

                            <Col md="12">
                                <Label className="form-label-sm">Monto</Label>
                                <Input
                                    type="number"
                                    name="amount_liquided"
                                    value={amount_liquided}
                                    invalid={amount_liquided_valid}
                                    placeholder="$ 0.0"
                                    step="any"
                                    className="form-control form-control-sm custom-input"
                                    onChange={handleInputChangeLiquided}
                                />
                            </Col>

                        </Row>

                        <Row>
                            <Col md="12" className="text-center pt-2">

                                {amount_liq < amount_liquided && (
                                    <div className="refund-positive txt-secondary" >
                                        Cambio $ {amount_liquided - amount_liq}
                                    </div>
                                )}

                                {amount_liq > amount_liquided && (
                                    <div className="refund-negative txt-secondary">
                                        Faltan $ {amount_liq - amount_liquided}
                                    </div>
                                )}

                            </Col>
                        </Row>

                    </Col>

                </Row>

            </Form>

        </Dialog>

    )
}











